import { IEvent } from "../../../models/Event"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays, faFileMedical, faFile, faAward, faVenusMars, faLocationDot, faStopwatch} from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState } from "react"
import { DetailsModal } from "./DetailsModal"

export const DetailsContent: React.FC<{ event: IEvent,target: number }> = ({ event, target }) => {
    const [activeSection, setActiveSection] = useState<string>('calendar')
    const [totalPrizes, setTotalPrizes] = useState<number>(0)

    useEffect(() => {
        checkPrizes()
    }, [])

    const checkPrizes = () => {
        let totalPrizes: number = 0;
        event.heats.map(heat => heat.prizes.map(prize => totalPrizes = totalPrizes + prize.nis))
        setTotalPrizes(totalPrizes)
    }

    const sections = [
        { name: 'calendar', title: 'לוז', icon: faCalendarDays, isShown: true },
        { name: 'prize', title: 'פרסים', icon: faAward, isShown: totalPrizes > 0 },
        { name: 'category', title: 'קטגוריות', icon: faVenusMars, isShown: true },
        { name: 'results', title: 'תוצאות', icon: faStopwatch, isShown: target < Date.now() },
        { name: 'location', title: 'הגעה', icon: faLocationDot, isShown: !!event.wazeDirection },
        { name: 'terms', title: 'תקנון', icon: faFile, isShown: !!event.termLinks },
        { name: 'medical', title: 'הצהרת בריאות', icon: faFileMedical, isShown: !!event.medicalLinks },
    ]

    return (
        <div id="DetailsContent" className="DetailsContent">
            <div className="details-icons">
                {sections.filter(section => section.isShown).map(section =>
                    <button
                        type="button"
                        key={section.name}
                        className={`details-tab${activeSection === section.name ? ' is-active' : ''}`}
                        aria-pressed={activeSection === section.name}
                        onClick={() => setActiveSection(section.name)}>
                        <FontAwesomeIcon className="icon" icon={section.icon} />
                        <span>{section.title}</span>
                    </button>
                )}
            </div>
            <div className="card details-panel" key={activeSection}>
                <DetailsModal event={event} modalText={activeSection} />
            </div>
        </div>
    )
}
